export default __webpack_public_path__ + "static/media/dsv-ups-dom_fr.75ec9afd.svg";